import styled from 'styled-components';
import { fontSize, screen } from 'theme';

const Root = styled.div`
  background-color: #bcf3e5;
  color: #03585a;
  padding: 1.5rem;
  font-size: ${fontSize('md')};
  border-radius: 2.5rem;

  @media (min-width: ${screen('md')}) {
  }
`;

export const CardHighlight04Styles = {
  Root
};
